import UIHeaders from '../subcomponents/UIHeaders';
import UINextStep from '../subcomponents/UINextStep';
import UIOptions from '../subcomponents/UIOptions';
import UIPreviousStep from '../subcomponents/UIPreviousStep';
import UIProjectOptions from '../subcomponents/UIProjectOptions';
import UITextDescription from '../subcomponents/UITextDescription';
import UIVoice from '../subcomponents/UIVoice';
import UIInsetsProps from '../subcomponents/UIInsetsProps';
import subComponentTypes from '../subcomponents/types';

export default function TCustomProps(props) 
{
	let properties = {}
	let customMap = props.customMap;
	if(!customMap) return properties;
	for(let i = 0 ; i< customMap.length; i++)
	{
		let key = customMap[i].type;
		switch(key)
		{
			case subComponentTypes.HEADERS:
				properties[subComponentTypes.HEADERS] = { ...UIHeaders({ ...props, size:customMap[i].size, anchor:'bottom', align:'left' }) };
				break;
			case subComponentTypes.INSETS:
				properties[subComponentTypes.INSETS] = { ...UIInsetsProps({ ...props, size:customMap[i].size }) };
				break;
			case subComponentTypes.NEXT_STEP:
				properties[subComponentTypes.NEXT_STEP] = { ...UINextStep({ ...props }) };
				break;
			case subComponentTypes.OPTIONS:
				properties[subComponentTypes.OPTIONS] = { ...UIOptions({ ...props, size:customMap[i].size, top:20 }) };
				break;
			case subComponentTypes.PREVIOUS_STEP:
				properties[subComponentTypes.PREVIOUS_STEP] = { ...UIPreviousStep({ ...props }) };
				break;
			case subComponentTypes.PROJECT_OPTIONS:
				properties[subComponentTypes.PROJECT_OPTIONS] = { ...UIProjectOptions({ ...props }) };
				break;
			case subComponentTypes.TEXT_DESCRIPTION:
				properties[subComponentTypes.TEXT_DESCRIPTION] = { ...UITextDescription({ ...props }) };
				break;
			case subComponentTypes.VOICE:
				properties[subComponentTypes.VOICE] = { ...UIVoice({ ...props }) };
				break;
		}
	}
	return properties;
}
